"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _DropDown = _interopRequireDefault(require("./DropDown"));
var _TopNav = require("../TopNav.style");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var RestLinks = function RestLinks(_ref) {
  var isDark = _ref.isDark,
    restLinks = _ref.restLinks,
    activeDropDown = _ref.activeDropDown,
    handleDropDownFocus = _ref.handleDropDownFocus,
    moreText = _ref.moreText;
  return /*#__PURE__*/_react.default.createElement(_DropDown.default, {
    className: activeDropDown == moreText && 'focus',
    onFocus: function onFocus() {
      return handleDropDownFocus(moreText);
    },
    link: {
      label: moreText
    },
    isDark: isDark
  }, restLinks.map(function (link, index) {
    return !link.dropdown ? /*#__PURE__*/_react.default.createElement(_TopNav.SubNavItem, {
      key: "rest-link-".concat(index)
    }, link) : /*#__PURE__*/_react.default.createElement(_TopNav.SubNavItem, {
      key: "rest-link-".concat(index, "-dropdown")
    }, link.link);
  }));
};
var _default = RestLinks;
exports.default = _default;